'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _ChatAvatar = require('ui-addon-messages/avatar/ChatAvatar');

var _ChatAvatar2 = _interopRequireDefault(_ChatAvatar);

var _BotAvatar = require('ui-addon-messages/avatar/BotAvatar');

var _BotAvatar2 = _interopRequireDefault(_BotAvatar);

var _AvatarTooltip = require('./AvatarTooltip');

var _AvatarTooltip2 = _interopRequireDefault(_AvatarTooltip);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: 'renderAvatar',
    value: function renderAvatar() {
      var isBot = (0, _responderGetters.getIsBot)(this.props.responder);
      var AvatarComponent = isBot ? _BotAvatar2.default : _ChatAvatar2.default;
      return _react2.default.createElement(AvatarComponent, {
        className: this.props.className,
        size: this.props.size,
        src: (0, _responderGetters.getAvatar)(this.props.responder) || ''
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          responder = _props.responder,
          isLastInGroup = _props.isLastInGroup,
          isInitialMessage = _props.isInitialMessage,
          showNameTooltip = _props.showNameTooltip,
          tooltipPlacement = _props.tooltipPlacement;


      if (!isLastInGroup || isInitialMessage) {
        return _react2.default.createElement('div', { className: 'p-x-3' });
      }

      return _react2.default.createElement(
        _AvatarTooltip2.default,
        {
          responder: responder,
          showTooltip: showNameTooltip,
          placement: tooltipPlacement
        },
        this.renderAvatar()
      );
    }
  }]);

  return Avatar;
}(_react.Component);

Avatar.displayName = 'Avatar';

Avatar.propTypes = {
  className: _react.PropTypes.string.isRequired,
  isInitialMessage: _react.PropTypes.bool,
  isLastInGroup: _react.PropTypes.bool,
  responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')]),
  showNameTooltip: _react.PropTypes.bool,
  size: _react.PropTypes.string.isRequired,
  tooltipPlacement: _react.PropTypes.string
};

Avatar.defaultProps = {
  className: '',
  size: 'extra-small',
  showNameTooltip: false
};

exports.default = Avatar;
module.exports = exports['default'];